__turbopack_context__.v({
  "table": "table-module-scss-module__r9oxzG__table",
});
